// Общие классы кнопок «Бумаги».
//
// Замечание владельца 24.09.2026: «Проблема или идея» и ещё несколько кнопок
// набраны голым текстом и от надписей не отличаются. Кнопка должна читаться
// кнопкой: плашка, рамка, отклик на наведение. Акцентная (розовая заливка) —
// только для главного действия экрана.

/** Второстепенная кнопка: белая плашка с рамкой, видна и на фоне страницы, и на карточке. */
export const BTN_SECONDARY = 'inline-flex items-center justify-center gap-[6px] whitespace-nowrap '
  + 'rounded-chip border border-paper-track bg-paper-card px-3 py-[6px] text-[13px] font-medium '
  + 'text-paper-ink hover:bg-paper-panel transition-colors disabled:text-paper-hint '
  + 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-paper-accent';

/** Небольшая акцентная кнопка — действие во всплывашке («Открыть», «Посмотреть»). */
export const BTN_ACCENT_SM = 'inline-flex items-center justify-center gap-[6px] whitespace-nowrap '
  + 'rounded-chip bg-paper-accent px-3 py-[6px] text-[13px] font-semibold text-white '
  + 'hover:bg-paper-accent-hover transition-colors disabled:bg-paper-bg disabled:text-paper-hint '
  + 'focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-paper-accent';
